import { ReactNode } from 'react';

interface LLRadioProps {
  children: ReactNode;
  customClass?: string;
}

const LLRadio: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & LLRadioProps
> = ({ id, name, children, checked, onChange, value, customClass }) => {
  return (
    <>
      <div className={`form-check ${customClass}`}>
        <input
          className="form-check-input"
          type="radio"
          name={name}
          id={id}
          checked={checked}
          onChange={onChange}
          value={value}
        />
        <label className="form-check-label ps-ll-10 pe-1" htmlFor={id}>
          {children}
        </label>
      </div>
    </>
  );
};

export default LLRadio;
